module.exports = __webpack_public_path__ + "img/tapecraft-logo.ad7a73cf.jpg";